module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/big/4-0b0cd1c716cd85a51ec1157aafc2b6e6.webp";